import { Grid, Box } from "@mantine/core";

export default function AuthLayout({ left, right }) {
    return (
        <Box
            h="100vh"
            style={{
                overflow: "hidden",
                background: "#f8f9fc"
            }}
        >
            <Grid h="100%" gutter={0}>
                <Grid.Col
                    span={{ base: 0, md: 6 }}
                    visibleFrom="md"
                >
                    {left}
                </Grid.Col>

                <Grid.Col
                    span={{ base: 12, md: 6 }}
                >
                    {right}
                </Grid.Col>
            </Grid>
        </Box>
    );
}